var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlannerNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_7536_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3604 13.3604L14.0372 19.4698L19.4698 14.0372L13.3604 13.3604Z",
    fill: "#FFAE46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7928 0L16.9819 14.5674H18.1892C19.1893 14.5674 20 13.7567 20 12.7565V0.301811C20 0.221766 19.9682 0.144999 19.9116 0.0883984C19.855 0.0317978 19.7783 0 19.6982 0L18.7928 0Z",
    fill: "#FFC85F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7928 12.7565V0H0.301811C0.221766 0 0.144999 0.0317978 0.0883984 0.0883984C0.0317978 0.144999 0 0.221766 0 0.301811L0 19.6982C0 19.7782 0.0317978 19.855 0.0883984 19.9116C0.144999 19.9682 0.221766 20 0.301811 20H12.7565C13.7567 20 14.5674 19.1893 14.5674 18.1891V14.5674H16.9819C17.982 14.5674 18.7928 13.7567 18.7928 12.7565Z",
    fill: "#FFE278"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#7A7E59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 11,
    height: 11,
    rx: 5.5,
    stroke: "#FFC85F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5714 14.4286H14.4286V16.5714C14.4286 16.6851 14.3834 16.7941 14.303 16.8745C14.2227 16.9548 14.1137 17 14 17C13.8863 17 13.7773 16.9548 13.697 16.8745C13.6166 16.7941 13.5714 16.6851 13.5714 16.5714V14.4286H11.4286C11.3149 14.4286 11.2059 14.3834 11.1255 14.303C11.0452 14.2227 11 14.1137 11 14C11 13.8863 11.0452 13.7773 11.1255 13.697C11.2059 13.6166 11.3149 13.5714 11.4286 13.5714H13.5714V11.4286C13.5714 11.3149 13.6166 11.2059 13.697 11.1255C13.7773 11.0452 13.8863 11 14 11C14.1137 11 14.2227 11.0452 14.303 11.1255C14.3834 11.2059 14.4286 11.3149 14.4286 11.4286V13.5714H16.5714C16.6851 13.5714 16.7941 13.6166 16.8745 13.697C16.9548 13.7773 17 13.8863 17 14C17 14.1137 16.9548 14.2227 16.8745 14.303C16.7941 14.3834 16.6851 14.4286 16.5714 14.4286Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7536_7427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlannerNotes);
export default __webpack_public_path__ + "static/media/add-planner-notes.dfa736fb415cbcbca24433d02d409303.svg";
export { ForwardRef as ReactComponent };